module.exports = __webpack_public_path__ + "img/operative_one-light-bkgd@2x.5bb3c5d0.png";